webpackJsonp([15],{

/***/ 1081:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_report_holding_invoice_vue__ = __webpack_require__(1193);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02b206c9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_report_holding_invoice_vue__ = __webpack_require__(1324);
function injectStyle (ssrContext) {
  __webpack_require__(1322)
}
var normalizeComponent = __webpack_require__(193)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02b206c9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_report_holding_invoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02b206c9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_report_holding_invoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1102:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);



// axios.defaults.timeout = 3000
// var TimeoutReq = {timeout: 60 * 5 * 1000}
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  PrintsendShiftHost: function PrintsendShiftHost(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/send/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  salePosDetail: function salePosDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/pos/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleDetail: function saleDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleCreditDetail: function saleCreditDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/credit/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleHoldDetail: function saleHoldDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/holdbill/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleSummary: function saleSummary(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/sale/total/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  expenseReport: function expenseReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/expense', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  expenseIncome: function expenseIncome(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/income', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  profitReport: function profitReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/profit/item/group', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  dailyReport: function dailyReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/send/shift', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  stockReport: function stockReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/stock/remain', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  movementReport: function movementReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/tran/item/section', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  holdingByCus: function holdingByCus(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/holdbill/remain', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  cancelBill: function cancelBill(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/pos/cancel', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  holdingByPaybill: function holdingByPaybill(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/holdbill/paybill/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  holdingByRemain: function holdingByRemain(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/pos/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleType: function saleType(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/sale/total/date', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleDocType: function saleDocType(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/report/sale/doctype/date', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleByItem: function saleByItem(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/sale/group/begin', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  reportSaleCustomer: function reportSaleCustomer(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/sale/customer', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  reportHoldbillInvoice: function reportHoldbillInvoice(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/holdbill/invoice', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  StandardReport: function StandardReport(URL, header, body, success, error) {
    console.log(body);
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/profit/v2/item/group', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  StandardCostReport: function StandardCostReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/item/cost/standard', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 1104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var config = {
  baseURL: "https://centralize.maeriminterfood.com",
  baseURLV2: "https://marim-mis-api.maeriminterfood.com"
  // baseURLV2: 'https://marim-api-test.undefined.co.th:4439'
  // baseURLV2: "http://localhost:6100"
};

/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),

/***/ 1105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  addSale: function addSale(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/new', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  UpdateSale: function UpdateSale(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/update', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  holdBill: function holdBill(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/holdbill', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  openShift: function openShift(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/shift/open', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  closeShift: function closeShift(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/shift/close', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getHostShift: function getHostShift(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.get(URL + 'company/v1/host/list', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getHostShiftDetail: function getHostShiftDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/shift/details', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  billList: function billList(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  printBill: function printBill(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/cash/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  printHolding: function printHolding(URL, body, header, success, error) {
    // Vue.axios.post(URL + 'sale/v1/pos/hold/slip', body, header).then(
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/dyn/v1/pos/hold/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  printBillCredit: function printBillCredit(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/credit/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  printPaybill: function printPaybill(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/paybill/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getSaleOnHost: function getSaleOnHost(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/report/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  cancelBill: function cancelBill(URL, body, header, success, error) {
    // Vue.axios.post(URL + 'sale/v1/pos/cancel', body, header).then(
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/dyn/v1/pos/cancel', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getHoldingBill: function getHoldingBill(URL, body, header, success, error) {
    // Vue.axios.post(URL + 'sale/v1/pos/holdbill/list', body, header).then(
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/dyn/v1/pos/hold/bill/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getReportBill: function getReportBill(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/pos/cancel', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  ExportMoney: function ExportMoney(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/shift/expense/new', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  PrintCloseShif: function PrintCloseShif(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/shift/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  openCashBox: function openCashBox(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/open/cashbox', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiveList: function receiveList(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/creditnote/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiveCancel: function receiveCancel(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/creditnote/cancel', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiveById: function receiveById(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/creditnote/id', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  billCreditList: function billCreditList(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/bill/receipt/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiveNew: function receiveNew(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/creditnote/new', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiveUpdate: function receiveUpdate(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/creditnote/update', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiptSearch: function receiptSearch(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/receipt/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiptDetail: function receiptDetail(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/receipt/id', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiptDel: function receiptDel(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/receipt/cancel', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  payBillCredit: function payBillCredit(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/receipt/new', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  printPayBillCredit: function printPayBillCredit(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/receipt/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getPosByDoc: function getPosByDoc(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/paybill/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getPosList: function getPosList(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/return/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  configDetail: function configDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/branch/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  billCreditDetail: function billCreditDetail(URL, header, body, success, error) {
    // Vue.axios.post(URL + 'sale/v1/pos/print/data', body, header).then(
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/dyn/v1/pos/print/data', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  billReceiptDetail: function billReceiptDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/receipt/id', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  slipExpend: function slipExpend(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/expense/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  slipIncome: function slipIncome(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/income/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  checkReturn: function checkReturn(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/check/return', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 1109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  listAll: function listAll(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/list/customer', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  removeCus: function removeCus(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/remove/customer', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  AddCus: function AddCus(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/add/customer', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  UpdateCus: function UpdateCus(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/update/customer', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 1110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(1104);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  updateSale: function updateSale(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/sale/updatesalesdetails', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  branch: function branch(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/branch', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  deleteHoldBil: function deleteHoldBil(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/sale/deleteHoldbill', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  roleUser: function roleUser(header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/users/roleUser', null, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  roleUserDelete: function roleUserDelete(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/users/roleUserDelete', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  roleUserGetCode: function roleUserGetCode(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/users/roleUserGetCode', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  roleUserGet: function roleUserGet(header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/users/roleUserGet', null, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  roleUserUpdate: function roleUserUpdate(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/users/roleUserUpdate', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  roleUserInsert: function roleUserInsert(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/users/roleUserInsert', body, header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  getRemainStock: function getRemainStock(body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/item/getRemainStock', body).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  changeStock: function changeStock(body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/item/changeStock', body).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  getItemGroup: function getItemGroup(success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/dashboard/getItemGroup', null).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 1193:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_service_report__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_service_pos__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_service_customer__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_service_undefined__ = __webpack_require__(1110);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      report_data: [],
      startDate: __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date()),
      endDate: __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date()),
      data_edit: {},
      header: {
        headers: {
          "Access-Token": sessionStorage.token
        }
      },
      form_data: "",
      form_host: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.host),
      branch: 0,
      host_list: [],
      host: null,
      data_cus_list: [],
      begin_code: "",
      end_code: "",
      dyn_address: "",
      show_item_detail: 0,
      show_cross_day: 0,
      show_no_pay: 0,
      modal_title: "",
      modal_active: false,
      item_color: [{ 'code': 0, 'name': 'ค้างชำระ' }, { 'code': 1, 'name': 'จ่ายแล้ว' }],
      sum_total_amount: 0,
      sum_invoice_amount: 0,
      sum_remain_amount: 0
    };
  },

  computed: {
    // filtersFunc () {
    //   return this.report_data.filter(item => {
    //     if (this.show_no_pay === 1 && this.show_cross_day === 0) {
    //       console.log('case1', item.hold_bill.length)
    //       for (let index = 0; index < item.hold_bill.length; index++) {
    //         return item.hold_bill[index].inv_no.indexOf('') < 1
    //       }
    //     }
    //     else if (this.show_no_pay === 0 && this.show_cross_day === 1) {
    //       console.log('case2')
    //       for (let index = 0; index < item.hold_bill.length; index++) {
    //         return item.hold_bill[index].create_time.substr(0, 10).indexOf(item.hold_bill[index].inv_time.substr(0, 10)) < 1
    //       }
    //       // return  item.hold_bill.indexOf(
    //       //   (f => f.create_time.substr(0, 10) != f.inv_time.substr(0, 10)) > -1
    //       // )
    //     }
    //     else if (this.show_no_pay === 1 && this.show_cross_day === 1) {
    //       console.log('case3')
    //       return item
    //     } else {
    //       console.log('case4')
    //       return item
    //     }
    //   })
    // },
  },
  methods: {
    save_modal: function save_modal() {
      var _this = this;

      if (this.data_edit.isStatus == 0 && this.data_edit.inv_no != '' && this.data_edit.inv_no != null) {
        // console.log(this.data_edit.branchName.replaceAll(" ", ''))
        __WEBPACK_IMPORTED_MODULE_6__services_service_undefined__["a" /* default */].deleteHoldBil({
          branchName: this.branch.branch_name,
          data: this.data_edit
        }, this.header, function (result) {
          _this.report_data.sum_total_amount += _this.data_edit.inv_total_amount;
          _this.report_data.sum_invoice_amount -= _this.data_edit.inv_total_amount;
          _this.sum_total_amount += _this.data_edit.inv_total_amount;
          _this.sum_invoice_amount -= _this.data_edit.inv_total_amount;
          _this.sum_remain_amount = _this.sum_total_amount - _this.sum_invoice_amount;
          _this.data_edit.sub = result.data.success;
          _this.data_edit.inv_no = null;
          _this.data_edit.isStatus = 0;
          _this.data_edit.bank_amount = 0;
          _this.data_edit.cash_amount = 0;
          _this.data_edit.inv_total_amount = 0;
          _this.data_edit.inv_time = null;
          _this.modal_active = false;
          _this.alert_msg("success", "บันทึกข้อมูลสำเร็จ", result.message);
        }, function (error) {
          _this.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", error.message);
        });
      } else {
        this.modal_active = false;
      }
    },
    close_modal: function close_modal() {},
    editHoldBild: function editHoldBild(e, branchName) {
      e['cashUnit'] = e.bank_amount > 0 ? 'เงินโอน' : 'เงินสด';
      e['isStatus'] = e.inv_no == '' || e.inv_no == null ? 0 : 1;
      e['branchName'] = branchName;
      this.data_edit = e;
    },
    filtersSub: function filtersSub(val) {
      var _this2 = this;

      return val.filter(function (item) {
        if (_this2.show_no_pay === 1 && _this2.show_cross_day === 0) {

          if (item.inv_no == "") {
            return item;
          }
        } else if (_this2.show_no_pay === 0 && _this2.show_cross_day === 1) {
          console.log("case2");
          if (item.create_time.substr(0, 10) != item.inv_time.substr(0, 10)) {
            return item;
          }
        } else if (_this2.show_no_pay === 1 && _this2.show_cross_day === 1) {
          console.log("case3");
          if (item.inv_no == "" && item.create_time.substr(0, 10) != item.inv_time.substr(0, 10)) {
            return item;
          }
        } else {
          console.log("case4");
          return item;
        }
      });
    },
    onSelectBranch: function onSelectBranch(val) {
      this.dyn_address = val.dyn_address;
      this.getCus();
    },
    filterOption: function filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    getReport: function getReport() {
      var _this3 = this;

      this.$store.commit("Loading");
      var branch = 0;
      this.report_data = [];
      this.form_data = "";
      if (this.branch !== 0) {
        branch = this.branch.id;
      }
      var obj = {
        id: branch,
        begin_date: this.dateDMY(this.startDate),
        end_date: this.dateDMY(this.endDate),
        company_id: 1,
        branch_id: 1,
        begin_ar: this.begin_code,
        end_ar: this.end_code
      };
      __WEBPACK_IMPORTED_MODULE_3__services_service_report__["a" /* default */].reportHoldbillInvoice(sessionStorage.Url, this.header, obj, function (result) {
        _this3.$store.commit("Loading");
        _this3.$store.state.isLoading = false;
        if (result.response === "success") {
          _this3.report_data = result.data;
          if (_this3.report_data.length > 0) {
            _this3.sum_total_amount = _this3.report_data[0].sum_total_amount;
            _this3.sum_invoice_amount = _this3.report_data[0].sum_invoice_amount;
            _this3.sum_remain_amount = _this3.report_data[0].sum_remain_amount;
          }
          _this3.form_data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this3.report_data);
        } else {
          _this3.alert_msg("warning", "ดึงข้อมูลรายงานไม่ได้", result.message);
        }
      }, function (error) {
        _this3.$store.commit("Loading");
        _this3.alert_msg("warning", "ดึงข้อมูลรายงานไม่ได้", error.message);
        _this3.$store.state.isLoading = false;
      });
    },
    getHost: function getHost() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_4__services_service_pos__["a" /* default */].getHostShift(sessionStorage.Url, this.header, function (result) {
        if (result.response === "success") {
          _this4.host_list = result.data;
          _this4.host = _this4.host_list[0];
          // this.getReport()
        } else {
          _this4.alert_msg("warning", "ดึงข้อมูลจุดขายไม่ได้", result.message);
        }
      }, function (error) {
        _this4.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", error.message);
      });
    },
    calQTY: function calQTY(obj) {
      var total = 0;
      obj.forEach(function (v) {
        total += v["qty"];
      });
      return total;
    },
    calAmount: function calAmount(obj) {
      var total = 0;
      obj.forEach(function (v) {
        total += v["amount"];
      });
      return total;
    },
    calAmountBranch: function calAmountBranch(obj) {
      var total = 0;
      obj.forEach(function (v) {
        total += v["total_amount"];
      });
      return total;
    },
    calAmountBranchAll: function calAmountBranchAll(obj) {
      var total = 0;
      // obj.forEach(v => {
      //   v.forEach(val => {
      //     total += val['total_amount']
      //   })
      // })
      return total;
    },
    capEnter: function capEnter() {
      $("a").on("keyup", function (e) {
        if (e.which == 13) {
          console.log(e.target.href);
        }
      });
    },
    getCus: function getCus() {
      var _this5 = this;

      this.$store.state.isLoading = true;
      var body = {
        keyword: "",
        limit: 100000,
        status: 1
      };
      __WEBPACK_IMPORTED_MODULE_2__services_service__["a" /* default */].callMisApi(this.dyn_address + "/" + "customer/v1/list/customer", {
        headers: {
          "Access-Token": this.branch.access_token
        }
      }, body, function (result) {
        if (result.response === "success") {
          _this5.data_cus_list = result.data;
        } else {
          _this5.alert_msg("warning", "ดึงข้อมูลลูกหนี้", result.message);
        }
        _this5.$store.state.isLoading = false;
      }, function (error) {
        _this5.alert_msg("warning", "ดึงข้อมูลลูกหนี้", error.message);
        _this5.$store.state.isLoading = false;
      });
    },
    timeFormat: function timeFormat(str) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(str).format("HH:mm:ss");
    },
    sum_qty: function sum_qty(obj) {
      var sumQty = 0;
      obj.forEach(function (val) {
        sumQty += val["cn_qty"];
      });
      return sumQty;
    },
    sum_total: function sum_total(obj) {
      var sum = 0;
      obj.forEach(function (val) {
        sum += val["total_amount"];
      });
      return sum;
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    this.checkUser();
    this.getHost();
    this.getBranch();

    setTimeout(function () {
      console.log(_this6.$store.state.branch_list);
      _this6.branch = _this6.$store.state.branch_list[0];
      _this6.dyn_address = _this6.$store.state.branch_list[0].dyn_address;
      _this6.getCus();
    }, 500);
  }
});

/***/ }),

/***/ 1322:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1323);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1046)("7d8fa5e2", content, true, {});

/***/ }),

/***/ 1323:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1045)(true);
// imports


// module
exports.push([module.i, ".head_table[data-v-02b206c9]{background-color:#ffffad}.head-branch[data-v-02b206c9]{font-size:18px;color:#000;font-weight:700}.table tbody[data-v-02b206c9]{border-bottom-style:solid;padding-bottom:5px}.table .thead-dark th[data-v-02b206c9]{color:#000;text-align:center;background-color:#6599ff;border-color:#383f45}.table .thead-footer th[data-v-02b206c9]{color:#000;text-align:center;background-color:#ffff}.text-no-val[data-v-02b206c9]{background-color:red;border-radius:8px;padding:3px;color:#fff!important}.havebankamount[data-v-02b206c9]{color:#8b4513!important;background-color:#adff2f!important}", "", {"version":3,"sources":["/Users/chakritkanpromkad/Developer/maeriminterfood/pos_mis-master/src/views/report_holding_invoice.vue"],"names":[],"mappings":"AACA,6BACE,wBAA0B,CAC3B,AACD,8BACE,eAAgB,AAChB,WAAoB,AACpB,eAAkB,CACnB,AACD,8BACE,0BAA2B,AAC3B,kBAAoB,CACrB,AACD,uCACE,WAAe,AACf,kBAAmB,AACnB,yBAA0B,AAC1B,oBAAsB,CACvB,AACD,yCACE,WAAe,AACf,kBAAmB,AACnB,sBAAwB,CACzB,AACD,8BACE,qBAAsB,AACtB,kBAAmB,AACnB,YAAa,AACb,oBAA0B,CAC3B,AACD,iCACE,wBAA8B,AAC9B,kCAAyC,CAC1C","file":"report_holding_invoice.vue","sourcesContent":["\n.head_table[data-v-02b206c9] {\n  background-color: #ffffad;\n}\n.head-branch[data-v-02b206c9] {\n  font-size: 18px;\n  color: rgb(0, 0, 0);\n  font-weight: bold;\n}\n.table tbody[data-v-02b206c9] {\n  border-bottom-style: solid;\n  padding-bottom: 5px;\n}\n.table .thead-dark th[data-v-02b206c9] {\n  color: #000000;\n  text-align: center;\n  background-color: #6599ff;\n  border-color: #383f45;\n}\n.table .thead-footer th[data-v-02b206c9] {\n  color: #000000;\n  text-align: center;\n  background-color: #ffff;\n}\n.text-no-val[data-v-02b206c9] {\n  background-color: red;\n  border-radius: 8px;\n  padding: 3px;\n  color: #ffffff !important;\n}\n.havebankamount[data-v-02b206c9] {\n  color: saddlebrown !important;\n  background-color: greenyellow !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"card card-solid",style:({ 'min-height': _vm.$store.state.screenHeight - 200 + 'px' })},[_c('div',{staticClass:"card-header pb-0"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group row col-sm-3 pb-0"},[_c('label',{staticClass:"col-sm-4 col-form-label text-right pb-0",attrs:{"for":"date"}},[_vm._v("ลูกค้าเริ่ม")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 pb-0"},[_c('a-select',{staticClass:"mr-sm-2 pb-0",staticStyle:{"width":"100%"},attrs:{"show-search":"","option-filter-prop":"children","filter-option":_vm.filterOption},model:{value:(_vm.begin_code),callback:function ($$v) {_vm.begin_code=$$v},expression:"begin_code"}},[_c('a-select-option',{attrs:{"value":""}},[_vm._v("\n                -- ไม่เลือก --\n              ")]),_vm._v(" "),_vm._l((_vm.data_cus_list),function(b,i){return _c('a-select-option',{key:'branch' + i,attrs:{"value":b.code}},[_vm._v("\n                "+_vm._s(b.code)+"/"+_vm._s(b.name)+"\n              ")])})],2)],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row col-sm-3 pb-0"},[_c('label',{staticClass:"col-sm-4 col-form-label text-right pb-0",attrs:{"for":"date"}},[_vm._v("ลูกค้าสุดท้าย")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 pb-0"},[_c('a-select',{staticClass:"mr-sm-2 pb-0",staticStyle:{"width":"100%"},attrs:{"show-search":"","option-filter-prop":"children","filter-option":_vm.filterOption},model:{value:(_vm.end_code),callback:function ($$v) {_vm.end_code=$$v},expression:"end_code"}},[_c('a-select-option',{attrs:{"value":""}},[_vm._v("\n                -- ไม่เลือก --\n              ")]),_vm._v(" "),_vm._l((_vm.data_cus_list),function(b,i){return _c('a-select-option',{key:'branch' + i,attrs:{"value":b.code}},[_vm._v("\n                "+_vm._s(b.code)+"/"+_vm._s(b.name)+"\n              ")])})],2)],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row col-sm-3 pb-0"},[_c('label',{staticClass:"col-sm-4 col-form-label text-right pb-0",attrs:{"for":"date"}},[_vm._v("เลือกสาขา")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 pb-0"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.branch),expression:"branch"}],staticClass:"custom-select mr-sm-2 pb-0",attrs:{"id":"Host"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.branch=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.onSelectBranch(_vm.branch)}]}},_vm._l((_vm.$store.state.branch_list),function(b,i){return _c('option',{key:'branch' + i,domProps:{"value":b}},[_vm._v(_vm._s(b.branch_name))])}),0)])]),_vm._v(" "),_c('div',{staticClass:"form-group row col-sm-3 pb-0"},[_c('label',{staticClass:"col-sm-4 col-form-label text-right pb-0",attrs:{"for":"date"}},[_vm._v("เฉพาะค้างชำระ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 pb-0"},[_c('a-select',{staticClass:"mr-sm-2 pb-0",staticStyle:{"width":"100%"},model:{value:(_vm.show_no_pay),callback:function ($$v) {_vm.show_no_pay=$$v},expression:"show_no_pay"}},[_c('a-select-option',{attrs:{"value":0}},[_vm._v(" ไม่ใช่ ")]),_vm._v(" "),_c('a-select-option',{attrs:{"value":1}},[_vm._v(" ใช่ ")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row col-sm-3 pb-0"},[_c('label',{staticClass:"col-sm-4 col-form-label text-right",attrs:{"for":"date"}},[_vm._v("จากวันที่")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('a-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":'DD/MM/YYYY'},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row col-sm-3 pb-0"},[_c('label',{staticClass:"col-sm-4 col-form-label text-right",attrs:{"for":"date"}},[_vm._v("ถึงวันที่")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('a-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":'DD/MM/YYYY'},model:{value:(_vm.endDate),callback:function ($$v) {_vm.endDate=$$v},expression:"endDate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row col-sm-3 pb-0"},[_c('label',{staticClass:"col-sm-4 col-form-label text-right pb-0",attrs:{"for":"date"}},[_vm._v("รูปแบบรายงาน")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 pb-0"},[_c('a-select',{staticClass:"mr-sm-2 pb-0",staticStyle:{"width":"100%"},model:{value:(_vm.show_item_detail),callback:function ($$v) {_vm.show_item_detail=$$v},expression:"show_item_detail"}},[_c('a-select-option',{attrs:{"value":0}},[_vm._v("\n                แบบแสดงรายละเอียด\n              ")]),_vm._v(" "),_c('a-select-option',{attrs:{"value":1}},[_vm._v(" แบบสรุป ")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row col-sm-3 pb-0"},[_c('label',{staticClass:"col-sm-4 col-form-label text-right pb-0",attrs:{"for":"date"}},[_vm._v("เฉพาะข้ามวัน")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 pb-0"},[_c('a-select',{staticClass:"mr-sm-2 pb-0",staticStyle:{"width":"100%"},model:{value:(_vm.show_cross_day),callback:function ($$v) {_vm.show_cross_day=$$v},expression:"show_cross_day"}},[_c('a-select-option',{attrs:{"value":0}},[_vm._v(" ไม่ใช่ ")]),_vm._v(" "),_c('a-select-option',{attrs:{"value":1}},[_vm._v(" ใช่ ")])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-2"}),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('button',{staticClass:"btn btn-success btn-block",attrs:{"type":"button"},on:{"click":_vm.getReport}},[_c('i',{staticClass:"fas fa-redo"}),_vm._v(" ประมวลผล\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('form',{attrs:{"action":"/static/pdf/report_sale_hold_invoice.php","method":"POST","target":"_blank"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate),expression:"startDate"}],attrs:{"type":"hidden","name":"date_start"},domProps:{"value":(_vm.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate),expression:"endDate"}],attrs:{"type":"hidden","name":"date_end"},domProps:{"value":(_vm.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_host),expression:"form_host"}],attrs:{"type":"hidden","name":"host"},domProps:{"value":(_vm.form_host)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_host=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_data),expression:"form_data"}],attrs:{"type":"hidden","name":"data"},domProps:{"value":(_vm.form_data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_data=$event.target.value}}}),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('form',{attrs:{"action":"/static/excel/report_sale_hold_invoice.php","method":"POST","target":"_blank"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate),expression:"startDate"}],attrs:{"type":"hidden","name":"date_start"},domProps:{"value":(_vm.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate),expression:"endDate"}],attrs:{"type":"hidden","name":"date_end"},domProps:{"value":(_vm.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_data),expression:"form_data"}],attrs:{"type":"hidden","name":"data"},domProps:{"value":(_vm.form_data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_data=$event.target.value}}}),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive-sm mt-3"},[_vm._v("\n        วันที่: "),_c('span',[_vm._v(_vm._s(_vm.dateFormatDMY(_vm.startDate)))]),_vm._v(" "),(_vm.dateFormatDMY(_vm.startDate) !== _vm.dateFormatDMY(_vm.endDate))?_c('span',[_vm._v("\n          ถึง วันที่: "+_vm._s(_vm.dateFormatDMY(_vm.endDate))+"\n        ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.report_data),function(d,i){return _c('table',{key:'branchData' + i,staticClass:"table"},[_c('thead',[_c('tr',{staticClass:"head-branch text-left"},[_c('th',{attrs:{"colspan":"2"}},[_vm._v("\n                สาขา: "+_vm._s(d ? d.branch_name : "-")+"/จุดขาย:\n                "+_vm._s(_vm.host.host_name)+"\n              ")]),_vm._v(" "),_c('th',{attrs:{"colspan":"6"}},[_vm._v("\n                รวมพักบิล(ช่วงเวลา):\n                "+_vm._s(_vm.numberFormatDecimal(_vm.sum_total_amount))+" / รวมบิลขาย:\n                "+_vm._s(_vm.numberFormatDecimal(_vm.sum_invoice_amount))+" / คงเหลือ:\n                "+_vm._s(_vm.numberFormatDecimal(_vm.sum_remain_amount))+"\n              ")])])]),_vm._v(" "),_vm._l((_vm.filtersSub(d.hold_bill)),function(r,i){return _c('tbody',{key:'datar' + i},[_c('tr',{staticClass:"text-left thead-dark head_table"},[_c('td',{attrs:{"colspan":"2"}},[_vm._v("\n                   เลขที่ใบพักบิล: "+_vm._s(r.doc_no)+"\n                "),(!r.inv_no)?_c('span',{staticClass:"text-no-val"},[_vm._v(" ค้างชำระ ")]):_vm._e()]),_vm._v(" "),_c('td',{attrs:{"colspan":"2"}},[_vm._v("\n                เวลา: "+_vm._s(_vm.dateFormatAndTime(r.create_time))+"\n              ")]),_vm._v(" "),_c('td',{attrs:{"colspan":"2"}},[_vm._v("ลูกค้า: "+_vm._s(r.ar_name || "-"))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                มูลค่า: "+_vm._s(_vm.numberFormatDecimal(r.total_amount))+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                มูลค่า: "+_vm._s(_vm.numberFormatDecimal(r.total_amount))+"\n              ")])]),_vm._v(" "),(_vm.show_item_detail === 0)?_c('tr',{staticClass:"thead-dark head_datail"},[_c('th',{attrs:{"width":"10%"}},[_vm._v("บาร์โค้ด")]),_vm._v(" "),_c('th',{attrs:{"width":"25%"}},[_vm._v("รายละเอียด")]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v("หน่วยนับ")]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v("ราคาขาย")]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v("ส่วนลด")]),_vm._v(" "),_c('th',{attrs:{"width":"15%"}},[_vm._v("ราคารวม")]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v("แก้ไข")])]):_vm._e(),_vm._v(" "),_vm._l((r.subs),function(s,i){return (_vm.show_item_detail === 0)?_c('tr',{key:'csub' + i},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(s.item_code))]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(s.item_name))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(s.item_unit))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                "+_vm._s(_vm.numberFormatDecimal(s.item_price))+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                "+_vm._s(_vm.numberFormatDecimal(s.item_qty))+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                "+_vm._s(_vm.numberFormatDecimal(s.item_dis_count_amount))+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                "+_vm._s(_vm.numberFormatDecimal(s.item_amount))+"\n              ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                "+_vm._s(_vm.numberFormatDecimal(s.item_amount))+"\n              ")])]):_vm._e()}),_vm._v(" "),_c('tr',{staticClass:"thead-footer"},[_c('th',{staticClass:"text-left",attrs:{"colspan":"2"}},[_vm._v("\n                เลขบิลขาย: "+_vm._s(r.inv_no || "-")+"\n              ")]),_vm._v(" "),_c('th',{staticClass:"text-left",staticStyle:{"color":"blue"}},[_vm._v("\n                เงินสด: "+_vm._s(_vm.numberFormatDecimal(r.cash_amount) || "-")+"\n              ")]),_vm._v(" "),(r.bank_amount <= 0)?_c('th',{staticClass:"text-left"},[_vm._v("\n                เงินโอน: "+_vm._s(_vm.numberFormatDecimal(r.bank_amount) || "-")+"\n              ")]):_c('th',{staticClass:"text-left",staticStyle:{"color":"black !important","background-color":"greenyellow !important"}},[_vm._v("\n                เงินโอน: "+_vm._s(_vm.numberFormatDecimal(r.bank_amount) || "-")+"\n              ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("\n                "+_vm._s(r.inv_time != "1990-01-01 00:00:00" ? r.inv_time : "-")+"\n              ")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("\n                "+_vm._s(_vm.numberFormatDecimal(r.inv_total_amount) || "-")+"\n              ")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("\n                "+_vm._s(_vm.numberFormatDecimal(r.inv_total_amount) || "-")+"\n              ")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-warning btn-sm",staticStyle:{"padding":"0 0.25rem","margin":"0.25rem"},attrs:{"type":"button"},on:{"click":function($event){_vm.modal_active = true;
                    _vm.modal_title = "แก้ไขข้อมูลใบพักบิล : " + (r.doc_no) + " ";
                    _vm.editHoldBild(r,d.branch_name);}}},[_c('i',{staticClass:"fas fa-edit"})])])])],2)}),_vm._v(" "),(_vm.report_data.length === 0)?_c('tbody',[_vm._m(2,true)]):_vm._e()],2)})],2),_vm._v(" "),_c('a-modal',{attrs:{"title":_vm.modal_title,"centered":""},on:{"ok":function($event){return _vm.save_modal()},"cancel":_vm.close_modal},model:{value:(_vm.modal_active),callback:function ($$v) {_vm.modal_active=$$v},expression:"modal_active"}},[_c('div',{staticClass:"form-group row mb-1"},[_c('label',{staticClass:"col-sm-3 text-right col-form-label",attrs:{"for":"vendor_name"}},[_vm._v("เลขที่บิลขาย")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data_edit.inv_no),expression:"data_edit.inv_no"}],staticClass:"form-control",attrs:{"type":"text","id":"vendor_name","disabled":"true","placeholder":"เลขที่บิลขาย...."},domProps:{"value":(_vm.data_edit.inv_no)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.data_edit, "inv_no", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row mb-1"},[_c('label',{staticClass:"col-sm-3 text-right col-form-label",attrs:{"for":"vendor_name"}},[_vm._v("รายละเอียด")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data_edit.ar_name),expression:"data_edit.ar_name"}],staticClass:"form-control",attrs:{"type":"text","id":"vendor_name","disabled":"true","placeholder":"รายละเอียด...."},domProps:{"value":(_vm.data_edit.ar_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.data_edit, "ar_name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row mb-1"},[_c('label',{staticClass:"col-sm-3 text-right col-form-label",attrs:{"for":"salePrice"}},[_vm._v("หน่วยนับ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.data_edit.cashUnit),expression:"data_edit.cashUnit",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"text","id":"salePrice","maxlength":"6","placeholder":"ราคาขาย....","disabled":"true"},domProps:{"value":(_vm.data_edit.cashUnit)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.data_edit, "cashUnit", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row mb-1"},[_c('label',{staticClass:"col-sm-3 text-right col-form-label",attrs:{"for":"salePrice"}},[_vm._v("ราคาขาย")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"salePrice","maxlength":"6","placeholder":"ราคาขาย....","disabled":"true"},domProps:{"value":_vm.numberFormatDecimal(_vm.data_edit.total_amount)}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row mb-1"},[_c('label',{staticClass:"col-sm-3 text-right col-form-label",attrs:{"for":"vendor_name"}},[_vm._v("ส่วนลด")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"vendor_name","disabled":"true","placeholder":"ส่วนลด....","value":"0.00"}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row mb-1"},[_c('label',{staticClass:"col-sm-3 text-right col-form-label",attrs:{"for":"vendor_name"}},[_vm._v("ราคารวม")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"vendor_name","disabled":"true"},domProps:{"value":_vm.numberFormatDecimal(_vm.data_edit.total_amount)}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row mb-1"},[_c('label',{staticClass:"col-sm-3 text-right col-form-label",attrs:{"for":"vendor_name"}},[_vm._v("สถานะจ่าย")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.data_edit.isStatus),expression:"data_edit.isStatus"}],staticClass:"form-control",attrs:{"id":"shift","disabled":_vm.data_edit.isStatus == 1 ? false :true},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.data_edit, "isStatus", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.item_color),function(dp,j){return _c('option',{key:j,domProps:{"value":dp.code}},[_vm._v(_vm._s(dp.name))])}),0)])])])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary btn-block",attrs:{"type":"submit"}},[_c('i',{staticClass:"far fa-file-pdf"}),_vm._v(" บันทึกเป็น PDF\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-info btn-block",attrs:{"type":"submit"}},[_c('i',{staticClass:"far fa-file-excel"}),_vm._v(" บันทึกเป็น Excel\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{attrs:{"scope":"row","colspan":"6"}},[_vm._v("ไม่มีข้อมูล")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/15.55829aa87cfc5ef2052a.js